<script>import { onMount, createEventDispatcher } from "svelte";
import { Grid } from "gridjs";
;
;
;
;
;
;
let node;
const dispatch = createEventDispatcher();
export let width = "100%";
export let height = "auto";
export let autoWidth = true;
export let fixedHeader = false;
export let resizable = false;
export let from = undefined;
export let language = undefined;
export let search = false;
export let sort = false;
export let pagination = false;
export let server = undefined;
export let columns = undefined;
export let data = undefined;
export let style = {};
export let className = {};
export const instance = new Grid({
    from,
    data,
    columns,
    server,
    search,
    sort,
    pagination,
    language,
    width,
    height,
    autoWidth,
    fixedHeader,
    style,
    className,
    resizable,
});
instance.on('cellClick', (...args) => dispatch('cellClick', Object.assign({}, args)));
instance.on('rowClick', (...args) => dispatch('rowClick', Object.assign({}, args)));
instance.on('beforeLoad', (...args) => dispatch('beforeLoad', Object.assign({}, args)));
instance.on('load', (...args) => dispatch('load', Object.assign({}, args)));
instance.on('ready', (...args) => dispatch('ready', Object.assign({}, args)));
onMount(() => {
    if (node) {
        instance.render(node);
    }
});
$: if (node) {
    instance
        .updateConfig({
        from,
        data,
        columns,
        server,
        search,
        sort,
        pagination,
        language,
        width,
        height,
        autoWidth,
        fixedHeader,
        style,
        className,
        resizable
    })
        .forceRender();
}
</script>

<article bind:this={node} />
